import { AxiosError, type AxiosResponse } from "axios";
import type { ConfigurationResponse, LoginRequest, LoginResponse, LoginSuccessData } from "./types";
import api from "../api/axios";
import { ENDPOINTS } from "../api/endpoints";

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    try {
      const response: AxiosResponse<LoginResponse> = await api.post("/api/v1/login", credentials);
      // Si la respuesta es exitosa, configurar el token en el header para futuras solicitudes
      if (response.data.success && response.data.content) {
        const token = response.data.content.accessToken;
        if (token) {
          sessionStorage.setItem("token", token);
          api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        }
      }

      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response) {
          return error.response.data as LoginResponse;
        } else if (error.request) {
          // La solicitud fue hecha pero no se recibió respuesta
        } else {
          // Algo sucedió al configurar la solicitud que provocó un error
        }
      }

      // Error genérico para cualquier otro tipo de error
      return {
        success: false,
        status: 500,
        content: {
          accessToken: "",
          refreshToken: "",
          accountId: "",
        } as LoginSuccessData,
      };
    }
  },
  getConfiguration: async (): Promise<any> => {
    try {
      const response: AxiosResponse<ConfigurationResponse> = await api.get(ENDPOINTS.CONFIGURATIONS.GET_CONFIG);
      if (response.data.success && response.data.content) {
        const token = response.data.content.accessToken;
        if (token) {
          sessionStorage.setItem("token", token);
          api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        }
      }

      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response) {
          return error.response.data as LoginResponse;
        } else if (error.request) {
          // La solicitud fue hecha pero no se recibió respuesta
        } else {
          // Algo sucedió al configurar la solicitud que provocó un error
        }
      }

      // Error genérico para cualquier otro tipo de error
      return {
        success: false,
        status: 500,
        content: {
          accessToken: "",
          refreshToken: "",
          accountId: "",
        } as LoginSuccessData,
      };
    }
  },
};
